import { GameResult } from 'features/firebase/types'

export const DEFAULT_RATING = 1000

export const expectedScore = (ratingA: number, ratingB: number): number => {
  return 1 / (1 + Math.pow(10, (ratingB - ratingA) / 400))
}

export const updateRatings = (ratingA: number, ratingB: number, resultA: number, K: number = 32): [number, number] => {
  const expectedA = expectedScore(ratingA, ratingB)
  const expectedB = expectedScore(ratingB, ratingA)

  const newRatingA = ratingA + K * (resultA - expectedA)
  const newRatingB = ratingB + K * (1 - resultA - expectedB)

  return [Math.round(newRatingA), Math.round(newRatingB)]
}

export const getGameScoreForWhite = (gameResult: GameResult) => {
  switch (gameResult.winner) {
    case 'white':
      return 1
    case 'draw':
      return 0.5
    case 'black':
      return 0
  }
}
